const EVENT = 'vurgun:game-card-overlay';

export function claimGameCardOverlay(id) {
  if (typeof window === 'undefined' || !id) return;
  window.dispatchEvent(new CustomEvent(EVENT, { detail: { id } }));
}

export function subscribeGameCardOverlay(id, onForeignOpen) {
  if (typeof window === 'undefined') return () => {};
  const handler = (e) => {
    if (e.detail?.id === id) return;
    onForeignOpen();
  };
  window.addEventListener(EVENT, handler);
  return () => window.removeEventListener(EVENT, handler);
}
